import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100% !important;
  overflow-y: hidden;
  overflow-x: hidden;
`;
